import React from 'react';
import { Box, Typography, Button, styled } from '@mui/material';
import { More, TabsIcons } from '../../assets';
import AddIcon from '@mui/icons-material/Add';


const CenteredBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
});

const NoDezignShark: React.FC = () => {
    const [isAddDezignSharkOpen, setIsAddDezignSharkOpen] = React.useState(false);

    const handleAddDezignSharkOpen = () => {
        setIsAddDezignSharkOpen(true);
    };

    const handleAddDezignSharkClose = () => {
        setIsAddDezignSharkOpen(false);
    };

    return (
        <>
        <CenteredBox>
            <Box sx={{ textAlign: 'center' }}>
                <img src={TabsIcons.UsersIcon} alt="No DezignShark" style={{height : '65px'}} />
                <Typography variant="h5" gutterBottom sx={{fontWeight: 'bold'}}>
                    There are no DezignShark
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<img src={More} alt="Add Builderss" style={{ width: '20px', filter: 'invert(100%)' }} />}
                    sx={{ mt: 1 }}
                    onClick={handleAddDezignSharkOpen}  
                >
                    Add New DezignShark
                </Button>
            </Box>
        </CenteredBox>

        </>
    );
};

export default NoDezignShark;
